import {
  AppBar,
  Badge,
  Dialog,
  IconButton,
  Slide,
  SlideProps,
  Toolbar,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from '@/feature/lang';
import { Icon } from '@/icon/Icon';
import { FilterModalProps } from './FilterModal';

const Transition = (props: SlideProps) => <Slide direction="up" {...props} />;

const FullScreenModal = ({ badgeContent, Content }: FilterModalProps) => {
  const [open, setOpen] = useState(false);
  const { texts, translate } = useTranslation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton onClick={handleClickOpen} size="large">
        <Badge badgeContent={badgeContent} color="primary">
          <Icon name="filter" />
        </Badge>
      </IconButton>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        slots={{
          transition: Transition,
        }}
      >
        <AppBar sx={{ position: 'relative' }} /*className={classes.appBar}*/>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              size="large"
            >
              <Icon name="close" />
            </IconButton>
            <Typography variant="h6" sx={{ flex: 1, ml: 2 }}>
              {translate(texts.component.layout.filterModal.title)}
            </Typography>
          </Toolbar>
        </AppBar>

        <Content onClose={handleClose} />
      </Dialog>
    </>
  );
};

export default FullScreenModal;
